import { useEffect, useState } from "react";
import { stalled } from "./matchWait";

/** True once the humans seated stayed the same for a minute with a seat still empty (decision 124). */
export function useStalled(humans: number, empty: number): boolean {
  const [mark, setMark] = useState(() => ({ humans, at: Date.now() }));
  if (mark.humans !== humans) setMark({ humans, at: Date.now() });
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 5_000);
    return () => window.clearInterval(id);
  }, []);
  return stalled({ humans, empty, changedAt: mark.at, now });
}
